import { Snackbar, Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { reaction } from "mobx";
import { inject, observer } from "mobx-react";
import React from "react";
import { CommonError, CommonsStore } from "../../model/CommonsStore";
import Alert from "@material-ui/lab/Alert";
import { SnackbarCloseReason } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    close: {
      padding: theme.spacing(1) / 2
    },
    error: {
      backgroundColor: theme.palette.error.main
    },
    success: {
      backgroundColor: "#67cc7c"
    },
    content: {
      margin: theme.spacing(1)
    },
    message: {
      display: "flex",
      alignItems: "center"
    }
  });

export interface SnacksProps extends WithStyles<typeof styles> {
  commons?: CommonsStore;
}

export interface SnacksState {
  open: boolean;
  error?: CommonError;
  success?: string;
  isError?: boolean;
}

@inject("commons")
@observer
class SnacksComponent extends React.Component<SnacksProps, SnacksState> {
  public state: SnacksState = {
    open: false
  };

  public constructor(props: SnacksProps) {
    super(props);

    reaction(
      () => this.props.commons!.error,
      () => {
        this.setState({
          open: true,
          error: this.props.commons!.error,
          isError: true
        });
      }
    );

    reaction(
      () => this.props.commons!.success,
      () => {
        this.setState({
          open: true,
          success: this.props.commons!.success,
          isError: false
        });
      }
    );
  }

  public render() {
    const content = this.createContent();
    const { classes } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        className={classes.content}
        onClick={this.handleClose}
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
      >
        {content}
      </Snackbar>
    );
  }

  public handleClose = (
    event: React.SyntheticEvent<any>,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }
    if (this.props.commons) {
      this.props.commons.closeSnacks();
    }
    this.setState({ open: false });
  };

  public createContent = () => {
    const severity = this.state.isError ? "error" : "success";
    const msg = this.state.error
      ? this.buildError(this.state.error)
      : this.state.success;
    return (
      <Alert
        elevation={6}
        variant="filled"
        severity={severity}
        onClose={this.handleClose}
      >
        {msg}
      </Alert>
    );
  };

  public buildError = (commonError: CommonError) => {
    if (commonError.errors && commonError.errors.length > 0) {
      return commonError.errors.map(e => (
        <div key={e.fieldName + e.message}>
          <b>{e.fieldName}:</b> {e.message}
        </div>
      ));
    }

    return commonError.message;
  };
}

export const Snacks = withStyles(styles)(SnacksComponent);
